import { Controller } from "@hotwired/stimulus";
import { Toast } from "bootstrap5";

export default class extends Controller {
  initialize() {
    this.remove = this.removeEl.bind(this);
  }

  connect() {
    var modal = Toast.getOrCreateInstance(this.element);
    modal.show();

    this.element.addEventListener("hidden.bs.toast", this.remove);
  }

  removeEl() {
    console.log("HIDDEN");
    $(this.element).parent(".toast_wrap").remove();
  }

  disconnect() {
    this.element.removeEventListener("hidden.bs.toast", this.remove);
  }
}
